import { ViewSupport4Component } from "../../../components/SupportSystem/ViewReports/ViewSupport4Component";
import { OperationReport4Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport4Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ViewSupport4Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport4Component />
            <Footer />
        </div>
    );
}
